import React, { useEffect, useRef, useState } from 'react';
import { useBOMStore } from "../../../../hooks/bom";
import { isArray, isObject } from "underscore";
import PriceTable from "../../../../component/custom/PriceTable";
import DisplayQtyMinQtyMult from "../../../../component/custom/DisplayQtyMinQtyMult";
import DisplayLifeCycleRisk from "../../../../component/custom/DisplayLifeCycleRisk";
import { useSelector } from "react-redux";
import BomRemovePart from "./BomRemovePart";
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import useReduxState from "../../../../hooks/useReduxState";
import datasheet2 from "src/assets/images/icon-file-pdf.png"
import AddToCart from 'src/component/custom/AddToCart';
import $ from "jquery";
import "floating-scroll";
import AxiosSingletonLoader from "../../../../component/Global/AxiosSingletonLoader";
import Helper from 'src/helper/Helper';
import ShowMoreLess from "../../../../component/custom/ShowMoreLess";
import CustomerPartNumberOptions from "../../../../component/custom/CustomerPartNumberOptions";
import useDebounce from "../../../../hooks/useDebounce";
import produceClone from "../../../../helper/produceClone";
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import Constants from 'src/helper/Constants';
import { useCartStore } from 'src/hooks/cart';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import BOMRepository from 'src/repository/BOMRepository';
import System from 'src/helper/system';
import stickyTableHeader from 'src/helper/stickyTableHeader';
import ReusableDiv from 'src/helper/ReusableDiv';
import NavigateToProductDetail from 'src/component/custom/NavigateToProductDetail';
import QuantityPicker from 'src/component/custom/QuantityPicker';
import ProductInventoryDisplay from 'src/component/custom/ProductInventoryDisplay';
import { useProductStore } from 'src/hooks/product';
import liveAuth from 'src/helper/liveAuth';
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';
import { Tooltip } from 'src/component/Global/Tooltip';

const BomExactMatchTable = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);
    const refLoadMore = useRef();
    const [checkAll, setCheckAll] = useState(false);
    const [top, SetTop] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const [quantityUpdateCallbackRunTime, SetQuantityUpdateCallbackRunTime] = useDebounce(false, 500);
    const [{ bom_detail_Exact_list, dynamic_field_activated, bom_detail_by_bom_id, selected_fields, bom_detail_by_bom_id_type, bom_project_list }, { get_bom_detail_by_bom_id_with_type }, { update_quantity_by_bom_detail_by_id, update_customer_part_number_by_bom_detail_by_id, update_bom_exact_match_record_with_cpn_quantity, load_all_selected_fields, remove_all_selected_fields, toggle_single_selected_fields }] = useBOMStore();
    const exactListRecord = bom_detail_Exact_list?.records
    const displayStatus = exactListRecord && Object.entries(exactListRecord).length > 0 ? true : false;
    const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    // const [{ }, { get_product_assets }, { }, { }] = useProductStore();
    // const [loadfetchInventoryFromServer, set_loadfetchInventoryFromServer] = useState(true);
    const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
    const [sortBy, setSortBy] = useState('');
    const [ascDesField, setAscDesField] = useState({});
    const [{ productList }, { }, { }] = useProductStore();
    const { bomDetailPageTabs, siteUser, systemModules: { BOM } } = Constants
    const bomTabType = System.getParams().__c_BomTabList || bomDetailPageTabs.BomExactMatchTable.content;
    const isCoreUser = System.avUserInfoData.currentUser === siteUser.CORE
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const isInternalUser = System.validateDomain(liveAuth.getAvUserInfo()?.email)
    const { translation: t, storageName: { BOM_OPENED, BOM_MULTI_MATCH, BOM_NO_MATCH_RESOLVE } } = System;

    useEffect(() => {
        setTimeout(() => {
            $(".floating-table").floatingScroll("init");
        }, 2000)
    }, [axios_indicator]);

    useEffect(() => {
        if (Object.entries(productSelected).length > 0) {
            SetTop({
                NoMatch: { top: 20 },
                Multiple: { top: 20 },
                Exact: { top: 20 }
            })
        }
    }, [productSelected]);

    const onSelectAll = (checked) => {
        setCheckAll(checked)
        onCheckAll(checked)
    }

    // useEffect(() => {
    //     if (displayStatus) {
    //         set_loadfetchInventoryFromServer(false)
    //     }
    // }, [displayStatus])

    useEffect(() => {
        setTimeout(() => {
            if (top?.Exact?.top > 20) {
                let topData = top?.Exact?.top
                document.getElementById('line' + (topData - 11)).scrollIntoView();
            }
        }, 5000);
    }, [top?.Exact?.top]);

    const getFilterData = (dataObj, isSingleObj = 'no') => {
        if (isSingleObj === 'yes') {
            const filterRes = Object.keys(dataObj).reduce((result, key) => {
                if (key.includes('bomDetailId') || key.includes('ERPPartNumber') || key.includes('quantity') || key.includes('product') || key.includes('product_contract_id') || key.includes('isDeleted') || key.includes('customerPartNumber') || key.includes('cpnTypeName') || key.includes('manualCPN')) {
                    result[key] = dataObj[key];
                }
                return result;
            }, {});
            return filterRes
        } else {
            const filterRes = Object.entries(dataObj).reduce((res, v) => {
                const result = Object.keys(v[1]).reduce((result, key) => {
                    if (key.includes('bomDetailId') || key.includes('ERPPartNumber') || key.includes('quantity') || key.includes('product') || key.includes('product_contract_id') || key.includes('isDeleted') || key.includes('customerPartNumber') || key.includes('cpnTypeName') || key.includes('manualCPN')) {
                        result[key] = v[1][key];
                    }
                    return result;
                }, {});
                res[v[0]] = result
                return res
            }, {})
            return filterRes
        }
    }

    const onCheckAll = (checked) => {
        if (checked) {
            if (exactListRecord && Object.entries(exactListRecord).length > 0) {
                const filterData = getFilterData(exactListRecord)
                load_all_selected_fields({ selected_fields: filterData })
            }
        } else {
            remove_all_selected_fields()
        }

    };

    const setStatusOfForFieldActivated = (singleDownloadColumnList) => {
        const filterData = getFilterData(singleDownloadColumnList, 'yes')
        toggle_single_selected_fields({ ...filterData })
    };

    const getStatusOfForFieldActivated = (singleDownloadColumnList) => {
        if (selected_fields && selected_fields[singleDownloadColumnList.bomDetailId]) {
            return selected_fields[singleDownloadColumnList.bomDetailId];
        }
        return false
    };

    // const fetchInventoryFromServer = async () => {
        // set_loadfetchInventoryFromServer(true);
        // const params = [];

        // Object.entries(exactListRecord).map((v) => {
        //     const param = productList[v[1].ItemNumber]
        //     if (param)
        //         params.push(param)
        // });

        // if (params && params.length) {
        //     await get_product_assets(params, { isPriceCall: false })
        // }
        // set_loadfetchInventoryFromServer(false);
    // };


    useEffect(() => {
        if (quantityUpdateCallbackRunTime) {
            quantityUpdateCallback(quantityUpdateCallbackRunTime.bomDetail, quantityUpdateCallbackRunTime.q);
        }
    }, [quantityUpdateCallbackRunTime]);

    const quantityUpdateCallback = (bomDetail, q) => {
        bomDetail = produceClone(bomDetail);
        bomDetail.quantity = q;
        update_bom_exact_match_record_with_cpn_quantity({ bomDetailId: bomDetail.bomDetailId, quantity: q })
        update_quantity_by_bom_detail_by_id([{ bomDetailsId: bomDetail.bomDetailId, quantity: q === '' ? 1 : q }])
        setTimeout(() => {
            const filterData = getFilterData(bomDetail, 'yes')
            toggle_single_selected_fields({ ...filterData, forceAdd: true })
        }, 300)
    }

    const cpnUpdateCallback = (bomDetail, cpn) => {
        bomDetail = produceClone(bomDetail);
        bomDetail.customerPartNumber = cpn;
        update_bom_exact_match_record_with_cpn_quantity({ bomDetailId: bomDetail.bomDetailId, customerPartNumber: cpn })
        setTimeout(() => {
            const filterData = getFilterData(bomDetail, 'yes')
            toggle_single_selected_fields({ ...filterData, forceAdd: true })
        }, 300)
    }

    const getLatestKey = () => {
        if (dynamic_field_activated && dynamic_field_activated[bom_detail_by_bom_id?.bomId]) {
            return Object.keys(dynamic_field_activated[bom_detail_by_bom_id.bomId]).length;
        }
        return ""
    }

    useEffect(() => {
        let refreshStockButton;
        let isDisplayFixedHeader = false;
        let callback;

        if (exactListRecord?.length > 0) {
            if (quantityUpdateCallbackRunTime) {
                SetQuantityUpdateCallbackRunTime(false)
            }

            const sort = null;
            const tableElement = document?.getElementById("bomexactmatch-table");
            // headerHeght contains height where we need to display static header
            // local
            // const headerHeight =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
            //sbx
            let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 156;

            const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

            if (adminToolBarHeight > 0) {
                headerHeight = headerHeight + adminToolBarHeight;
            }

            document.addEventListener("scroll", (ScrollEvent) => {
                const tablePosition = tableElement && tableElement.getBoundingClientRect() ? tableElement.getBoundingClientRect().y : false;
                const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")[0]?.getBoundingClientRect()?.y : false;

                if (tablePosition && headerHeight > tablePosition && !isNaN(paginationPosition) && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
                    callback = stickyTableHeader("bomexactmatch-table", headerHeight, "sticky-table-wrapper", 1, sort)
                    isDisplayFixedHeader = true;
                    // refreshStockButton = document.getElementsByClassName("refresh-link")
                    // refreshStockButton[refreshStockButton.length - 1].addEventListener("click", fetchInventoryFromServer);

                    if (document.getElementsByClassName('parent-check-input').length > 0) {
                        document.getElementsByClassName('parent-check-input')[document.getElementsByClassName('parent-check-input').length - 1].addEventListener('change', (evt) => onSelectAll(evt.currentTarget.checked))
                    }
                } else {
                    if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                        isDisplayFixedHeader = false;
                        if (document.getElementsByClassName('parent-check-input').length > 0 && onSelectAll) {
                            document.getElementsByClassName('parent-check-input')[document.getElementsByClassName('parent-check-input').length - 1]?.removeEventListener("change", onSelectAll);
                        }
                        // if (refreshStockButton && refreshStockButton[refreshStockButton.length - 1] && fetchInventoryFromServer) {
                        //     refreshStockButton[refreshStockButton.length - 1]?.removeEventListener("click", fetchInventoryFromServer);
                        // }

                        if (Object.prototype.toString.call(callback) == '[object Function]') {
                            callback();
                        }
                    }
                }
            })
            return () => {
                if (callback) {
                    isDisplayFixedHeader = false;
                    if (document.getElementsByClassName('parent-check-input').length > 0 && onSelectAll) {
                        document.getElementsByClassName('parent-check-input')[document.getElementsByClassName('parent-check-input').length - 1]?.removeEventListener("change", onSelectAll);
                    }
                    // if (refreshStockButton && refreshStockButton[refreshStockButton.length - 1] && fetchInventoryFromServer) {
                    //     refreshStockButton[refreshStockButton.length - 1]?.removeEventListener("click", fetchInventoryFromServer);
                    // }
                    callback();
                    __check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status && window.scrollTo(0, 0)
                }
            }
        }
    }, [bom_detail_Exact_list, __check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status])

    const toggleOrderBy = async (columnName) => {
        if (ascDesField.hasOwnProperty(columnName)) {
            ascDesField[columnName] = ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setAscDesField(ascDesField)
        } else {
            ascDesField[columnName] = 'ASC'
            setAscDesField(ascDesField)
        }
        setSortBy(columnName)

        let top_here = 10;
        if (top[bomDetailPageTabs[bomTabType].api_fetch_type] && top[bomDetailPageTabs[bomTabType].api_fetch_type].top) {
            top_here = top[bomDetailPageTabs[bomTabType].api_fetch_type].top;
        }
        top_here = top_here === 10 ? 20 : (top_here - 1);

        let param = {
            bomId: System.getParams().bomId,
            matchType: bomDetailPageTabs[bomTabType].api_fetch_type,
            top: top_here,
            skip: 0,
            sortColumn: columnName,
            sortOrder: ascDesField[columnName]
        }

        await get_bom_detail_by_bom_id_with_type(param);
    };

    const getOrderByClass = (columnName) => {
        if (sortBy === columnName && ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    const getPriceByCPN = (ele) => {
        return get_pricing_by_id({ uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber })
    }

    useEffect(() => {
        let bomInfo = {
            bomId: bom_detail_by_bom_id?.bomId,
            bomTitle: bom_detail_by_bom_id?.bomName,
            bomProjectName: bom_project_list && bom_project_list[bom_detail_by_bom_id?.projectId]?.projectName || '',
            newBOM: bom_detail_by_bom_id?.newBOM,
            sourceOfBOM: bom_detail_by_bom_id?.source || 'upload',
            exactMatchesReturned: bom_detail_by_bom_id_type?.Exact?.count,
            multipleMatchesReturned: bom_detail_by_bom_id_type?.Multiple?.count,
            noMatchesReturned: bom_detail_by_bom_id_type?.NoMatch?.count,
        };
        if (bom_detail_Exact_list && Object.keys(bom_detail_Exact_list?.records)?.length && localStorage.getItem(BOM_OPENED)) {
            let productListItems = [];
            for (const [key, value] of Object.entries(bom_detail_Exact_list?.records)) {
                let priceVal = getPriceByCPN(value)
                if (isArray(priceVal) && priceVal.length > 0) {
                    priceVal = priceVal[0]
                }
              productListItems.push({
                SKU: value?.ItemNumber,
                name: value?.ERPPartNumber || value?.erpPartNumber,
                currencyCode: value?.currency || window?.mct,
                quantity: value?.quantity,
                priceTotal: value?.subtotal ||  (priceVal?.marketPrice && priceVal?.quantity ? (priceVal.marketPrice * priceVal.quantity).toFixed(2) : '') || '',
                productImageUrl:value?.AssetURL || "",
                merchandising: {
                erpPartKey:value?.ERPPartNumber || value?.partNumber,
                pimPartKey:value?.ItemNumber || value.itemNumber,
                supplierID:value?.ERPSupplierCode || "",
                supplierName: value?.supplierName || "",
                supplierPartNumber:value?.supplierPartNumber || "",
                manufacturerID: value.ManufacturerCode || value.manufacturerCode || value.ERPManufacturerCode || "",
                manufacturerName: value.ManufacturerName || value.manufacturerName || value.ERPManufacturerName || "",
                manufacturerPartNumber: value.manufacturerPartNumber || value.ManufacturerPartNumber || value.ERPMFRPartNumber || "",
                quantityAddedToBOM: value?.Quantity || value?.quantity,
                 quantityAvailableForSale: get_inventory_by_id(value?.ItemNumber)?.inventoryQty || 0,
                backOrderedQuantity: value?.backOrderedQuantity || value?.backOrderQuantity || "",
                displayedPrice: value?.unitPrice || priceVal?.marketPrice || "",
                displayedPriceType: priceVal?.priceSource || "",
                }
              });
            }

            HelperAnalyticsEvent.bomOpened({ productListItems: productListItems, bomInfo: bomInfo })
            localStorage.removeItem(BOM_OPENED);
        }
        if (Object.keys(productSelected)?.length > 0 && bom_detail_Exact_list && Object.keys(bom_detail_Exact_list?.records)?.length > 0) // Quickly Add part
        {
            let bomDetail = Object.values(bom_detail_Exact_list?.records).filter(x => x.itemNumber === productSelected.ItemNumber)?.map(x => ({ seqNo: x.sequenceNumber, bomDetailId: x.bomDetailId }));

            if (bomDetail?.length > 1) {
                bomDetail = bomDetail.reduce((max, current) => {
                    return (current.seqNo > max.seqNo) ? current : max;
                }, { seqNo: null, bomDetail: null })
            }
            else if (bomDetail) {
                bomDetail = bomDetail[0]
            }

            if (bomDetail) {
                let priceVal = get_pricing_by_id({ uniqueId: bomDetail?.bomDetailId || productSelected?.ItemNumber });
                if (isArray(priceVal) && priceVal.length > 0) {
                    priceVal = priceVal[0]
                }
                let productListItem = {
                    SKU: productSelected?.ItemNumber,
                    name: productSelected?.ERPPartNumber || productSelected?.erpPartNumber,
                    currencyCode: productSelected?.currency || window?.mct,
                    quantity: productSelected?.quantity || productSelected?.QtyMin,
                    priceTotal: productSelected?.subtotal || (priceVal?.marketPrice && priceVal?.quantity ? (priceVal.marketPrice * priceVal.quantity).toFixed(2) : '') || '',
                    merchandising: {
                        category: productSelected?.categoryListing || '',
                        erpPartKey: productSelected?.ERPPartNumber || productSelected?.partNumber,
                        pimPartKey: productSelected?.ItemNumber || productSelected.itemNumber,
                        supplierID: productSelected?.ERPSupplierCode || "",
                        supplierName: productSelected?.supplierName || "",
                        supplierPartNumber: productSelected?.supplierPartNumber || "",
                        manufacturerID: productSelected.ManufacturerCode || productSelected.manufacturerCode || productSelected.ERPManufacturerCode || "",
                        manufacturerName: productSelected.ManufacturerName || productSelected.manufacturerName || productSelected.ERPManufacturerName || "",
                        manufacturerPartNumber: productSelected.manufacturerPartNumber || productSelected.ManufacturerPartNumber || productSelected.ERPMFRPartNumber || "",
                        quantityAddedToBOM: productSelected?.Quantity || productSelected?.quantity || productSelected?.QtyMin,
                        quantityAvailableForSale: productSelected?.Stock || 0,
                        displayedPrice: productSelected?.unitPrice || priceVal?.marketPrice || ""
                    }
                }
                HelperAnalyticsEvent.bomQuicklyAddPart({ productListItems: [productListItem], bomInfo: bomInfo })
                setProductSelected({})
            }
        }
        if (localStorage.getItem(BOM_MULTI_MATCH + '_' + bom_detail_by_bom_id?.bomId)) {
            let selectedProd = JSON.parse(localStorage.getItem(BOM_MULTI_MATCH + '_' + bom_detail_by_bom_id?.bomId));
            if (selectedProd) {
                let productArr = isArray(selectedProd) ? selectedProd : [selectedProd];
                if (productArr.length > 0) {
                    productArr = productArr.map((x) => {
                        let priceObj = get_pricing_by_id({ ItemNumber: x?.itemNumber })?.[0];
                        return {
                            ...x,
                            qas: get_inventory_by_id({ ItemNumber: x?.itemNumber })?.inventoryQty || 0,
                            unitPrice: x.unitPrice || priceObj?.marketPrice || 0,
                            subtotal: x.subtotal || (priceObj?.marketPrice * priceObj?.quantity) || 0,
                            quantity: x.Quantity || priceObj?.quantity,
                            priceSource: priceObj?.priceSource || ''
                        }
                    });
                }
                let bomSearchMatch = {
                    productList: productArr,
                    bomInfo: bomInfo
                }
                HelperAnalyticsEvent.bomMultipleMatch(bomSearchMatch);
                localStorage.removeItem(BOM_MULTI_MATCH + '_' + bom_detail_by_bom_id.bomId);
            }
        }
    }, [bom_detail_Exact_list, bom_detail_by_bom_id, bom_detail_by_bom_id_type, bom_project_list])
    return (
        <>
            <div className="tab-content p-0">
                <div id='sticky-table-wrapper' key={"table-refresh" + getLatestKey()}
                    className={__check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status ?
                        "floating-table table-responsive loader-wrapper-outer minh350 mb-0" :
                        "floating-table table-responsive  mb-0 sticky-table-wrapper"}
                >

                    {__check(['BOM_TAB_API_CALL', 'BOM_API_CALL'], { overlay: true }).render}

                    <table id='bomexactmatch-table' className={isCoreUser ? "bs5 table table-bordered table-exact-match sticky-table-six" : "bs5 table table-bordered table-exact-match sticky-table-five"}>
                        <thead style={{ display: displayStatus ? '' : 'none' }}>
                            <tr>
                                <th className="w40"></th>
                                <th className="text-nowrap w40">
                                    <div className="form-check font-15 d-flex align-items-center ps-0">
                                        <input type="checkbox" checked={exactListRecord && Object.entries(selected_fields).length == Object.entries(exactListRecord).length} className="form-check-input parent-check-input ps-0 ms-0"
                                            onClick={(e) => {
                                                setCheckAll(e.target.checked)
                                                onCheckAll(e.target.checked)
                                            }} />
                                        <label className="form-check-label mt-0" htmlFor="customCheck1"></label>
                                    </div>
                                </th>
                                <th className="text-nowrap minw200">{t('partNumber')}</th>
                                <th className="text-nowrap minw220">{t('manufacturerPartNumber')}</th>
                                {isCoreUser &&
                                    <th className="text-nowrap minw210">
                                        {t('customerPartNumber')}
                                        <Tooltip opener={() => (<i className="fa fa-info-circle ms-1" />)} content={() => (t('clickToSelectCPN'))} />
                                    </th>
                                }
                                <th className="text-nowrap minw150">{t('quantity')}</th>
                                <th className="text-nowrap minw200">{t('price')}</th>
                                <th className="text-nowrap minw260">{t('availability')}</th>
                                <th className="text-nowrap">{t('manufacturer')}</th>
                                <th className="text-nowrap">{t('information')}</th>
                                {isInternalUser &&
                                    <th className={'text-nowrap ' + getOrderByClass('design_win_flag')}
                                        onClick={async () => { await toggleOrderBy('design_win_flag') }}>{t('designRegisterable')}</th>
                                }
                                {dynamic_field_activated[bom_detail_by_bom_id.bomId] &&
                                    isObject(dynamic_field_activated[bom_detail_by_bom_id.bomId]) &&
                                    Object.entries(dynamic_field_activated[bom_detail_by_bom_id.bomId]).map((v) => (
                                        <th key={v[1].columnName} className="text-nowrap">{v[1].fileColumnName}</th>
                                    )
                                    )}
                            </tr>
                        </thead>
                        <tbody>
                            {displayStatus &&
                                Object.entries(exactListRecord).map((v, i) => (
                                    <React.Fragment key={v[1].sequenceNumber}>
                                        <tr className="align-top" key={v[1].sequenceNumber} id={'line' + i}>
                                            <td>
                                                <span className="index-count">{v[1].sequenceNumber}</span>
                                            </td>
                                            {!v[1].isDeleted &&
                                                <>
                                                    <td>
                                                        <div className="form-check font-12 d-flex align-items-center ps-0 minh-0">
                                                            <input type="checkbox" className="form-check-input ps-0 ms-0 mt-0"
                                                                onChange={(e) => {
                                                                    setStatusOfForFieldActivated(v[1])
                                                                }}
                                                                checked={getStatusOfForFieldActivated(v[1])}
                                                                id={'checkBox' + v[1].bomDetailId}
                                                                name={'checkBox' + v[1].bomDetailId} />
                                                            <label className="form-check-label mt-0"
                                                                htmlFor={'checkBox' + v[1].bomDetailId}
                                                                onChange={(e) => {
                                                                    setStatusOfForFieldActivated(v[1])
                                                                }} />
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="d-flex w-100 justify-content-between align-items-center">
                                                            <div>
                                                                {v[1].partNumber}
                                                            </div>
                                                            <BomRemovePart bomId={v[1].bomId} bomDetailId={v[1].bomDetailId} singleBomDetail={v[1]} source={'ExactMatch'} />
                                                        </div>

                                                        {(productList[v[1].ItemNumber] && v[1].bom_alternative_object &&
                                                            v[1].bom_alternative_object.Count &&
                                                            v[1].bom_alternative_object.Count > 0) &&
                                                            <div className="d-flex align-items-center mt-3">
                                                                <AxiosSingletonLoader overlay={true} slugKey={['PRODUCT_LISTING_API_CALL']}>
                                                                    <a className="text-blue2"
                                                                        onClick={() => {
                                                                            const { ItemNumber } = v[1];
                                                                            const p = productList[ItemNumber] ? v[1] : {};
                                                                            System.popup('AlternativeBomPopup', { selected_product: p });
                                                                        }} >
                                                                        <i className="fa fa-exchange font-16 ms-2 cursor-pointer text-black me-2"></i>
                                                                        {t('viewAlternatives')}
                                                                    </a>
                                                                </AxiosSingletonLoader>
                                                            </div>
                                                        }
                                                    </td>
                                                    <td>
                                                        {productList[v[1].ItemNumber] &&
                                                            <>
                                                                <div className="font-14 font-bold">
                                                                    <NavigateToProductDetail data={{ ManufacturerName: productList[v[1].ItemNumber].ManufacturerName, ERPMFRPartNumber: productList[v[1].ItemNumber].ERPMFRPartNumber, ItemNumber: v[1].ItemNumber, ERPPartNumber: productList[v[1].ItemNumber].ERPPartNumber, seoItemNumber: productList[v[1].ItemNumber].seoItemNumber }}>
                                                                        {productList[v[1].ItemNumber].ERPMFRPartNumber}
                                                                    </NavigateToProductDetail>
                                                                </div>
                                                                <ShowMoreLess single_product={productList[v[1].ItemNumber]} />
                                                                <div className="sect-row">
                                                                    <span className="datasheet me-0">
                                                                        <span className="lifecycle low-risk"
                                                                            aria-hidden="true"
                                                                            data-toggle="tooltip"
                                                                            data-placement="bottom" data-html="true"
                                                                            data-title={t('lowRiskContent')}                                                                        >
                                                                            <DisplayLifeCycleRisk single_product={productList[v[1].ItemNumber]} isFrom={Constants.systemModules.BOM} />
                                                                        </span>
                                                                    </span>
                                                                    {productList[v[1].ItemNumber].DatasheetUrl ?
                                                                        <span className="datasheet">
                                                                            <a className="datasheet-align img-text mt-0 pt-0 ms-0 text-black"
                                                                                rel="nofollow"
                                                                                href={productList[v[1].ItemNumber].DatasheetUrl}
                                                                                title={productList[v[1].ItemNumber].ManufacturerPartNumber + " Datasheet"}
                                                                                target="_new">
                                                                                <img className='me-1' src={datasheet2} />
                                                                                <span
                                                                                    className='vertical-align-text-top'>{t('datasheet')}</span>
                                                                            </a>
                                                                        </span>
                                                                        :
                                                                        ReusableDiv.dataSheetTooltip()
                                                                    }

                                                                </div>
                                                            </>
                                                        }
                                                    </td>
                                                    {isCoreUser &&
                                                        <td>

                                                            <div className='bomcpn'>
                                                                {productList[v[1].ItemNumber] &&
                                                                    <CustomerPartNumberOptions
                                                                        single_product={productList[v[1].ItemNumber]}
                                                                        from={BOM}
                                                                        defaultValue={v[1].customerPartNumber}
                                                                        unique_id={v[1].bomDetailId}
                                                                        updationCompletedCallback={async (SELECTED_CUSTOMER_PART_NUMBER) => {
                                                                            let CPNValue = v[1].customerPartNumber
                                                                            if (CPNValue !== SELECTED_CUSTOMER_PART_NUMBER) {
                                                                                let param = {
                                                                                    bomDetailId: v[1].bomDetailId,
                                                                                    customerPartNumber: SELECTED_CUSTOMER_PART_NUMBER
                                                                                }
                                                                                cpnUpdateCallback(v[1], SELECTED_CUSTOMER_PART_NUMBER);
                                                                                await update_customer_part_number_by_bom_detail_by_id(param)
                                                                            }
                                                                        }}
                                                                    />
                                                                }
                                                            </div>
                                                        </td>
                                                    }
                                                    <td className='text-left'>
                                                        <>
                                                            {productList[v[1].ItemNumber] &&
                                                                <>
                                                                    <QuantityPicker
                                                                        single_product_inventory={get_inventory_by_id(v[1].ItemNumber)}
                                                                        single_product={productList[v[1].ItemNumber]}
                                                                        force_default_quantity={v[1].quantity}
                                                                        isFrom={BOM}

                                                                        qp_unique_id={v[1].bomDetailId}
                                                                        disable_increase_decrease={true}
                                                                        disable_edit_force_default_quantity={true}
                                                                        single_product_pricing_list={getPriceByCPN(v[1])}
                                                                        getPlanInputQuantityCallback={
                                                                            (q) => SetQuantityUpdateCallbackRunTime({
                                                                                bomDetail: v[1],
                                                                                q
                                                                            })
                                                                        }
                                                                    />

                                                                    <div
                                                                        className="text-start small-text light light-text collapse_minmax text-nowrap">
                                                                        <DisplayQtyMinQtyMult
                                                                            single_product={productList[v[1].ItemNumber]}
                                                                        />
                                                                    </div>
                                                                </>
                                                            }
                                                            {!productList[v[1].ItemNumber] &&
                                                                <>
                                                                    <div className="d-flex w-100 justify-content-between align-items-center">
                                                                        <div className="form-control form-control-sm">
                                                                            <span className='mt-1 d-block'>{v[1].quantity}</span>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            }
                                                        </>
                                                    </td>
                                                    <td>
                                                        {productList[v[1].ItemNumber] &&
                                                            <>
                                                                <PriceTable
                                                                    isDisplayCPN={false}
                                                                    single_product_inventory={get_inventory_by_id(v[1].ItemNumber)}
                                                                    single_product={productList[v[1].ItemNumber]}
                                                                    single_product_pricing_list={getPriceByCPN(v[1])}
                                                                />
                                                                <AddToCart
                                                                    single_product_pricing_list={getPriceByCPN(v[1])}
                                                                    single_product_inventory={get_inventory_by_id(v[1].ItemNumber)}
                                                                    single_product={productList[v[1].ItemNumber]}
                                                                    do_not_display_add_to_cart_button={true}
                                                                    selected_cpn={CART_BEFORE_TO_SEND_SERVER[v[1].ItemNumber]?.CPN || ''}
                                                                    isFrom={BOM}
                                                                />
                                                            </>
                                                        }
                                                    </td>
                                                    <td>
                                                        {productList[v[1].ItemNumber] &&
                                                            <ProductInventoryDisplay single_product={productList[v[1].ItemNumber]}
                                                                single_product_inventory={get_inventory_by_id(v[1].ItemNumber)} />
                                                        }
                                                    </td>
                                                    <td>
                                                        {productList[v[1].ItemNumber] && productList[v[1].ItemNumber].ManufacturerName && productList[v[1].ItemNumber].ManufacturerName.trim() !== '' ? (
                                                            <>{productList[v[1].ItemNumber].ManufacturerName}</>
                                                        ) : (
                                                            <div className='text-center mt-3'>-</div>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <div className="prod-option-icon sect-2 d-flex flex-wrap">
                                                            <ProductLegends single_product={productList[v[1].ItemNumber]}
                                                                onlyIcon={true} />
                                                        </div>
                                                    </td>
                                                    {isInternalUser &&
                                                        <td>
                                                            {v[1]?.designWinFlag}
                                                        </td>
                                                    }
                                                </>
                                            }
                                            {v[1].isDeleted &&
                                                <><td></td>
                                                    <td>{t('deleted')}: {v[1].manufacturerPartNumber}</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                </>
                                            }
                                            {dynamic_field_activated[bom_detail_by_bom_id.bomId] &&
                                                isObject(dynamic_field_activated[bom_detail_by_bom_id.bomId]) &&
                                                Object.entries(dynamic_field_activated[bom_detail_by_bom_id.bomId]).map((v_inner) => (
                                                    <td key={v[1][v_inner[1].columnName] + Helper.UUID()}>
                                                        {v[1][v_inner[1].columnName] &&
                                                            <>
                                                                {v[1][v_inner[1].columnName]}
                                                            </>
                                                        }
                                                        {(!v[1][v_inner[1].columnName] || v[1][v_inner[1].columnName].trim() === '') &&
                                                            <>
                                                                <div className='text-center mt-3'>
                                                                    -
                                                                </div>
                                                            </>
                                                        }
                                                    </td>
                                                )
                                                )}
                                        </tr>
                                    </React.Fragment>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="pagination-row text-center">
                {displayStatus &&
                    Object.entries(exactListRecord).length < (bom_detail_Exact_list?.count + bom_detail_Exact_list?.deleted) &&
                    !__check(['BOM_TAB_API_CALL', 'BOM_API_CALL', 'CART_API_CALL']).status && (
                        <button
                            ref={refLoadMore}
                            onClick={() => SetTop(BOMRepository.loadMore(top, props))}
                            className="bs5 m-t-30 m-b-30 btn btn-secondary w155"
                        >
                            {t('loadMore')}
                        </button>
                    )
                }
            </div>

        </>
    );
}

export default BomExactMatchTable;